export const semanticColourTokens = {
  dialog: {
    backdrop: {
      value: 'rgba(0, 0, 0, 0.80)',
    },
  },
  surface: {
    canvas: {
      value: {
        base: '{colors.assiduous.neutral.50}',
        _dark: '{colors.assiduous.neutral.900}',
      },
    },
    panel: {
      value: {
        base: '{colors.assiduous.neutral.0}',
        _dark: '{colors.assiduous.neutral.800}',
      },
    },
    subtle: {
      value: {
        base: '{colors.assiduous.neutral.100}',
        _dark: '{colors.assiduous.neutral.700}',
      },
    },
  },
  text: {
    primary: {
      value: {
        base: '{colors.assiduous.neutral.900}',
        _dark: '{colors.assiduous.neutral.50}',
      },
    },
    secondary: {
      value: {
        base: '{colors.assiduous.neutral.700}',
        _dark: '{colors.assiduous.neutral.300}',
      },
    },
    muted: {
      value: {
        base: '{colors.assiduous.neutral.500}',
        _dark: '{colors.assiduous.neutral.400}',
      },
    },
    inverse: {
      value: {
        base: '{colors.assiduous.neutral.0}',
        _dark: '{colors.assiduous.neutral.900}',
      },
    },
  },
  border: {
    default: {
      value: {
        base: '{colors.assiduous.neutral.200}',
        _dark: '{colors.assiduous.neutral.700}',
      },
    },
    strong: {
      value: {
        base: '{colors.assiduous.neutral.300}',
        _dark: '{colors.assiduous.neutral.600}',
      },
    },
  },
  input: {
    search: {
      border: { value: '{colors.assiduous.search.border}' },
    },
  },
  action: {
    primary: {
      bg: {
        value: {
          base: '{colors.assiduous.blue.600}',
          _dark: '{colors.assiduous.blue.400}',
        },
      },
      hover: {
        value: {
          base: '{colors.assiduous.blue.700}',
          _dark: '{colors.assiduous.blue.300}',
        },
      },
      active: {
        value: {
          base: '{colors.assiduous.blue.800}',
          _dark: '{colors.assiduous.blue.200}',
        },
      },
      subtle: {
        value: {
          base: '{colors.assiduous.blue.50}',
          _dark: '{colors.assiduous.blue.900}',
        },
      },
      fg: { value: '{colors.assiduous.neutral.0}' },
    },
    strong: {
      bg: { value: '{colors.assiduous.ink}' },
      hover: { value: '{colors.assiduous.neutral.800}' },
      active: { value: '{colors.assiduous.neutral.700}' },
      fg: { value: '{colors.assiduous.neutral.0}' },
    },
    supporting: {
      border: { value: '{colors.assiduous.supporting.border}' },
      fg: { value: '{colors.assiduous.supporting.text}' },
    },
    danger: {
      bg: { value: '{colors.assiduous.danger.600}' },
      hover: { value: '{colors.assiduous.danger.700}' },
      active: { value: '{colors.assiduous.danger.800}' },
      subtle: {
        value: {
          base: '{colors.assiduous.danger.50}',
          _dark: '{colors.assiduous.danger.700}',
        },
      },
      fg: { value: '{colors.assiduous.neutral.0}' },
    },
  },
  focus: {
    ring: {
      value: {
        base: '{colors.assiduous.blue.500}',
        _dark: '{colors.assiduous.blue.300}',
      },
    },
  },
  admin: {
    table: {
      surface: {
        value: {
          base: '{colors.assiduous.neutral.0}',
          _dark: '{colors.assiduous.neutral.800}',
        },
      },
      header: {
        value: {
          base: '{colors.assiduous.neutral.50}',
          _dark: '{colors.assiduous.neutral.800}',
        },
      },
      divider: {
        value: {
          base: '{colors.assiduous.neutral.100}',
          _dark: '{colors.assiduous.neutral.700}',
        },
      },
      hover: {
        value: {
          base: '{colors.assiduous.neutral.50}',
          _dark: '{colors.assiduous.neutral.700}',
        },
      },
      selected: {
        value: {
          base: '{colors.assiduous.blue.50}',
          _dark: '{colors.assiduous.blue.900}',
        },
      },
      group: {
        value: {
          base: '{colors.assiduous.blue.700}',
          _dark: '{colors.assiduous.blue.300}',
        },
      },
    },
  },
  advisory: {
    surface: {
      hero: { value: { base: '#fbfcff', _dark: '#161b24' } },
      grid: { value: { base: '#f8fafc', _dark: '#151a22' } },
    },
    rim: {
      hero: {
        value: {
          base: 'rgba(15, 23, 42, 0.12)',
          _dark: 'rgba(255, 255, 255, 0.18)',
        },
      },
      grid: {
        value: {
          base: 'rgba(15, 23, 42, 0.1)',
          _dark: 'rgba(255, 255, 255, 0.12)',
        },
      },
    },
    depth: {
      hero: {
        ambient: {
          value: {
            base: 'rgba(15, 23, 42, 0.16)',
            _dark: 'rgba(0, 0, 0, 0.62)',
          },
        },
        contact: {
          value: {
            base: 'rgba(15, 23, 42, 0.24)',
            _dark: 'rgba(0, 0, 0, 0.74)',
          },
        },
        glow: {
          value: {
            base: 'rgba(99, 102, 241, 0.14)',
            _dark: 'rgba(125, 211, 252, 0.18)',
          },
        },
        rim: {
          value: {
            base: 'rgba(255, 255, 255, 0.9)',
            _dark: 'rgba(255, 255, 255, 0.16)',
          },
        },
      },
      grid: {
        ambient: {
          value: {
            base: 'rgba(15, 23, 42, 0.1)',
            _dark: 'rgba(0, 0, 0, 0.48)',
          },
        },
        contact: {
          value: {
            base: 'rgba(15, 23, 42, 0.16)',
            _dark: 'rgba(0, 0, 0, 0.58)',
          },
        },
        glow: {
          value: {
            base: 'rgba(59, 130, 246, 0.08)',
            _dark: 'rgba(125, 211, 252, 0.1)',
          },
        },
        rim: {
          value: {
            base: 'rgba(255, 255, 255, 0.72)',
            _dark: 'rgba(255, 255, 255, 0.11)',
          },
        },
      },
    },
  },
}
